export default __webpack_public_path__ + "static/media/meetpharma-homepage-picture1.0efe9020.jpg";